import {Button, Input} from "antd";
import {EditIcon} from "../../assets/icons/EditIcon";
import useAppContext from "../../hooks/useAppContext";
import useUserContext from "../../hooks/useUserContext";
import {useEffect, useState} from "react";
import {updateInvoiceDetails} from "../../api/updateInvoiceDetails";

const InvoiceDetailsEditor = ({ onUpdate }: { onUpdate: () => void; }) => {
    const { data: { shop }, actions: { loadShop }} = useAppContext();
    const { user, selectedDomain } = useUserContext();
    const [isEditMode, setIsEditMode] = useState(false);
    const [invoiceName, setInvoiceName] = useState<string>(shop.data?.invoiceDetails?.name || user?.name || '');
    const [invoiceCompanyNumber, setInvoiceCompanyNumber] = useState<string>(shop.data?.invoiceDetails?.companyNumber || '');

    const onUpdateInvoiceDetails = async () => {
        if(selectedDomain) {
            const response = await updateInvoiceDetails(selectedDomain, invoiceName, invoiceCompanyNumber);
            if(response.data.status === 'success') {
                loadShop();
                onUpdate();
            }
            setIsEditMode(false);
        }
    }

    useEffect(() => {
        setInvoiceName(shop.data?.invoiceDetails?.name || user?.name || '');
        setInvoiceCompanyNumber(shop.data?.invoiceDetails?.companyNumber || '');
    }, [shop]);

    return (
        <div className={`invoice-details ${isEditMode ? 'edit-mode' : ''}`}>
            <div className="title">Details on Invoice:</div>
            {isEditMode ? <>
                <div className="invoice-details-fields">
                    <div className="invoice-field edit-field invoice-name">Name on invoice: <Input value={invoiceName} onChange={(event: any) => setInvoiceName(event.target.value)} /></div>
                    <div className="invoice-field edit-field invoice-company-number">Company Number: <Input value={invoiceCompanyNumber} onChange={(event: any) => setInvoiceCompanyNumber(event.target.value)} /></div>
                </div>
                <div className="actions">
                    <Button type="default" size="middle" onClick={() => setIsEditMode(false)}>Cancel</Button>
                    <Button type="primary" size="middle" onClick={onUpdateInvoiceDetails}>Update Details</Button>
                </div>
            </> : <>
                <div className="invoice-field invoice-name">Name: <span>{shop.data?.invoiceDetails?.name || user?.name || '-'}</span></div>
                <div className="invoice-field invoice-company-number">Company Number: <span>{shop.data?.invoiceDetails?.companyNumber || '-'}</span></div>
                <Button type="primary" icon={<EditIcon width={18} height={18} />} className="invoice-details-edit-btn" onClick={() => setIsEditMode(true)} />
            </>}
        </div>
    )
}

export default InvoiceDetailsEditor;